import {
  IInventory,
  ISupplier,
  IWarehouseStock,
} from 'src/types/common/inventory';
import { ProductItem } from 'src/types/common/product';
export { ProductItem };

export enum EType {
  Add = 'Add',
  Set = 'Set',
}
export type InventoryProduct = {
  available?: number;
  inventoryUuid?: string;
  warehouseStocks?: IWarehouseStock[];
  // product: ProductItem;
} & ProductItem;

export interface IFetchIventories {
  suppliers: ISupplier[];
  inventories: {
    countPerPage: number;
    firstRow: number;
    resultSize: number;
    totalCount: number;
    results: IInventory<InventoryProduct>[];
  };
}
